import { z } from 'zod';

export const StorageUnitKindSchema = z.enum([
  'frigo_positivo',
  'frigo_negativo',
  'abbattitore',
  'dispensa',
  'cella_frigo',
  'vetrina',
  'altro',
]);
export type StorageUnitKind = z.infer<typeof StorageUnitKindSchema>;

export const STORAGE_TEMP_DEFAULTS: Record<
  StorageUnitKind,
  { min: number | null; max: number | null }
> = {
  frigo_positivo: { min: 0, max: 4 },
  frigo_negativo: { min: -25, max: -18 },
  abbattitore: { min: -40, max: 10 },
  dispensa: { min: 10, max: 25 },
  cella_frigo: { min: -2, max: 4 },
  vetrina: { min: 2, max: 8 },
  altro: { min: null, max: null },
};

export const StorageUnitSchema = z.object({
  id: z.string().uuid(),
  tenant_id: z.string().uuid(),
  business_id: z.string().uuid(),
  name: z.string().min(1).max(200),
  kind: StorageUnitKindSchema,
  location_note: z.string().nullable(),
  temp_min_c: z.number().nullable(),
  temp_max_c: z.number().nullable(),
  check_frequency_hours: z.number().int().positive().default(24),
  assigned_personnel_ids: z.array(z.string().uuid()).default([]),
  requires_photo: z.boolean().default(false),
  active: z.boolean().default(true),
  created_at: z.string().datetime(),
  archived_at: z.string().datetime().nullable(),
  version: z.number().int().nonnegative().default(0),
});
export type StorageUnit = z.infer<typeof StorageUnitSchema>;
